import {
  FORMULA_FIELD_ENTITIES,
  FormulaFieldEntity,
  IFormulaFieldDataModel,
  normalizeFormulaFieldType,
} from '../../data-models/formula-field.data-model';
import { MaggieHttp } from '../MaggieHttp';

/** Fields saved before entity support (or unknown BE values) → 'company'. */
function normalizeEntity(entity: unknown): FormulaFieldEntity {
  return FORMULA_FIELD_ENTITIES.includes(entity as FormulaFieldEntity)
    ? (entity as FormulaFieldEntity)
    : 'company';
}

/** A field as the api returns it, with the values the model can hold — on reads and on writes alike. */
function normalizeFormulaField(field: IFormulaFieldDataModel): IFormulaFieldDataModel {
  return { ...field, entity: normalizeEntity(field.entity), type: normalizeFormulaFieldType(field.type) };
}

export async function fetchFormulaFields() {
  const { data } = await MaggieHttp.maggie.get<IFormulaFieldDataModel[]>('/field/formula');
  return data.map(normalizeFormulaField);
}

export async function createFormulaField(payload: Partial<IFormulaFieldDataModel>) {
  const { data } = await MaggieHttp.maggie.post<Partial<IFormulaFieldDataModel>, IFormulaFieldDataModel>(
    '/field/formula',
    payload
  );
  return normalizeFormulaField(data);
}

export async function updateFormulaField(payload: Partial<IFormulaFieldDataModel>) {
  const { data } = await MaggieHttp.maggie.put<Partial<IFormulaFieldDataModel>, IFormulaFieldDataModel>(
    `/field/formula/${payload.id}`,
    payload
  );
  return normalizeFormulaField(data);
}

export async function deleteFormulaField(field: IFormulaFieldDataModel) {
  await MaggieHttp.maggie.delete<number>(`/field/formula/${field.id}`);
  return field;
}
